import axios from 'axios';

const request = async (method, url, data = undefined, handleError = false) => {
  axios.defaults.headers[method]['Content-Type'] =
    'application/x-www-form-urlencoded';
  const session = localStorage.getItem('session');
  axios.defaults.headers[method]['X-Parse-Session-Token'] = session;

  try {
    // TODO(haopan): There is probably a better way to do this. Figure it out.
    return axios[method](url, data);
  } catch (error) {
    if (handleError) {
      throw error;
    } else {
      return undefined;
    }
  }
};

const get = async (url, handleError = false) =>
  request('get', url, undefined, handleError);
const put = async (url, data, handleError = false) =>
  request('put', url, data, handleError);
const post = async (url, data, handleError = false) =>
  request('post', url, data, handleError);
const del = async (url, data, handleError = false) =>
  request('delete', url, data, handleError);

export { get, put, post, del };
